if ( typeof HoculusUGCSwiper !== 'function' ) {

    customElements.whenDefined('hoculus-swiper-slider').then(SwiperSlider => {

        class HoculusUGCSwiper extends SwiperSlider {
            constructor() {
                super();
    
                const onVideoEnded = () => {
                    this.swiper.slideNext();
                }

                super.loadSwiper().then(() => {
                    const _this = this;
        
                    const has3dEffect = this.closest('.hoculus-ugc-content')?.classList?.contains('effect-3d');

                    this.swiper = new Swiper(this, {
                        loop: has3dEffect,
                        slidesPerView: has3dEffect ? 2 : 1.5,
                        spaceBetween: has3dEffect ? 0 : 30,
                        centeredSlides: true,
                        breakpoints: {
                            1400: {
                                slidesPerView: 5,
                            },
                            1200: {
                                slidesPerView: 4,
                            },
                            768: {
                                slidesPerView: 3,
                            }
                        },
                        on: {
                            slideChange: function() {
                                _this.video?.pause();
                                _this.video?.removeEventListener('ended', onVideoEnded);
        
                                _this.video = this.slides[this.activeIndex].querySelector('video');
        
                                if (_this.video && _this.video.ended) {
                                    _this.video.currentTime = 0;
                                }
        
                                _this?.video.play();
                                _this?.video.addEventListener('ended', onVideoEnded);
                            },
                            init: function() {
                                setTimeout(() => {
                                    _this.video = this.slides[this.activeIndex].querySelector('video');
                                    _this.video?.play();
                                    _this.video?.addEventListener('ended', onVideoEnded);

                                    _this.classList.remove('is-loading');
                                }, 500);
                            }
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                    });
                });

                this.addEventListener('click', this.onClick.bind(this));

            }

            onClick(event) {
                const el = event.target;

                if (!el.matches('.ugc-video__audio-button')) {
                    return;
                }

                this.video.muted = !this.video.muted;
                this.video.classList.toggle('is-muted', this.video.muted);
            }
        }
    
        if ( typeof customElements.get('hoculus-ugc-swiper') == 'undefined' ) {
            customElements.define('hoculus-ugc-swiper', HoculusUGCSwiper);
        }

    });


}

